import React, { FC } from 'react';

const Edit: FC<any> = ({ stroke = '#000' }: any) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33355 4.49998L12.0002 7.16665M2.78468 14.3431L4.0668 14.0867C4.53764 13.9925 4.77306 13.9454 4.99259 13.8593C5.18745 13.7829 5.37263 13.6838 5.54431 13.564C5.73773 13.4291 5.90749 13.2594 6.24702 12.9198L13.246 5.92089C13.51 5.65688 13.642 5.52488 13.6914 5.37266C13.735 5.23876 13.735 5.09453 13.6914 4.96064C13.642 4.80842 13.51 4.67641 13.246 4.4124L12.0878 3.25423C11.8238 2.99022 11.6918 2.85821 11.5396 2.80875C11.4057 2.76525 11.2614 2.76525 11.1275 2.80875C10.9753 2.85821 10.8433 2.99022 10.5793 3.25423L3.58036 10.2532C3.24083 10.5927 3.07106 10.7625 2.93616 10.9559C2.81643 11.1276 2.71732 11.3128 2.6409 11.5076C2.55479 11.7271 2.5077 11.9626 2.41353 12.4334L2.15711 13.7155C2.10465 13.9778 2.07842 14.109 2.11712 14.2025C2.15096 14.2843 2.21593 14.3492 2.29771 14.3831C2.39125 14.4218 2.52239 14.3955 2.78468 14.3431Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Edit;
